module.exports = __webpack_public_path__ + "static/media/fotokapak.69d564c1.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/albums/fotokapak.jpeg
// module id = 280
// module chunks = 0